module.exports = __webpack_public_path__ + "static/toggl-track-unexpected-tasks-202967e5ee7cf24cf3d8743f9fad4222.jpg";